"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Creative = _interopRequireDefault(require("../models/creative/Creative"));

var _AudioCreativeLayer = _interopRequireDefault(require("../models/creative/AudioCreativeLayer"));

var _isNil = _interopRequireDefault(require("../utils/object/isNil"));

var _containsInclusive = _interopRequireDefault(require("../utils/numbers/containsInclusive"));

var _isNotNil = _interopRequireDefault(require("../utils/object/isNotNil"));

var _isNotEmpty = _interopRequireDefault(require("../utils/array/isNotEmpty"));

var _AudioLayer = _interopRequireDefault(require("./audio/AudioLayer"));

var _AudioFactory = _interopRequireDefault(require("./audio/AudioFactory"));

/*
 SnapAudio plays stuff in to a canvas context
 */
var SnapAudio = /*#__PURE__*/function () {
  function SnapAudio(creative, audioFactory) {
    (0, _classCallCheck2["default"])(this, SnapAudio);
    (0, _defineProperty2["default"])(this, "_audibleCreativeLayersByElementId", new Map());
    (0, _defineProperty2["default"])(this, "_creative", null);
    (0, _defineProperty2["default"])(this, "_elementAudio", new Map());
    (0, _defineProperty2["default"])(this, "_speed", 1);
    (0, _defineProperty2["default"])(this, "_audioFactory", null);

    if (!_Creative["default"].isCreative(creative)) {
      throw new Error('creative must be of type Creative');
    }

    if (!_AudioFactory["default"].isAudioFactory(audioFactory)) {
      throw new Error('audioFactory must be of type AudioFactory');
    } // audio in order


    this.creative = creative;
    this._audioFactory = audioFactory;
  }

  (0, _createClass2["default"])(SnapAudio, [{
    key: "cleanUp",
    value: function cleanUp() {
      this.stopAll();

      this._elementAudio.forEach(function (audioLayer, key) {
        var audio = audioLayer.audio;
        if ((0, _isNil["default"])(audio)) return;
        audio.clear();
      });

      this._elementAudio.clear();
    }
  }, {
    key: "loadAudioThatHasNotBeenLoaded",
    value: function loadAudioThatHasNotBeenLoaded() {
      var _this = this;

      this._audibleCreativeLayersByElementId.forEach(function (audibleCreativeLayer, elementId) {
        if (_this._elementAudio.has(elementId)) return;

        var webAudio = _this._audioFactory.getAudio(audibleCreativeLayer, _this._speed);

        _this._elementAudio.set(elementId, new _AudioLayer["default"](audibleCreativeLayer, webAudio));
      });
    }
  }, {
    key: "playAudioThatShouldBePlaying",
    value: function playAudioThatShouldBePlaying(creativeLayer, currentFrame) {
      var uppermostAudioElementId = creativeLayer.elementId;

      var _creativeLayer$getRel = creativeLayer.getRelativeFrameIndicesAndTimesAtFrame(currentFrame),
          endIndex = _creativeLayer$getRel.endIndex,
          frameIndex = _creativeLayer$getRel.frameIndex,
          startIndex = _creativeLayer$getRel.startIndex;

      var playingAudioLayer = this._elementAudio.get(uppermostAudioElementId);

      if ((0, _isNil["default"])(playingAudioLayer)) return;

      var shouldUpdateAudio = _AudioLayer["default"].isAudioLayerOutOfDate(playingAudioLayer, creativeLayer); // if audio layer is out of date, get an updated one


      if (shouldUpdateAudio) {
        // Clear old audio
        if ((0, _isNotNil["default"])(playingAudioLayer.audio)) {
          playingAudioLayer.audio.clear();
        }

        playingAudioLayer.audio = this._audioFactory.getAudio(creativeLayer, playingAudioLayer.speed);
        playingAudioLayer.creativeLayer = creativeLayer;
      }

      var playingAudio = playingAudioLayer.audio;
      var frameIndexIsOutOfBounds = !(0, _containsInclusive["default"])(frameIndex, startIndex, endIndex);

      if (frameIndexIsOutOfBounds) {
        if (playingAudio.isPlaying) {
          playingAudio.stop();
        }
      } else {
        playingAudio.play(frameIndex - startIndex);
      }
    }
  }, {
    key: "setUpAudioLayers",
    value: function setUpAudioLayers() {
      // set up audio layers
      // Get the expected uppermost audio element
      var audibleCreativeLayers = _Creative["default"].getOrderedCreativeLayersByType(this.creative, _AudioCreativeLayer["default"]);

      var audibleCreativeLayersByElementId = new Map();
      audibleCreativeLayers.forEach(function (audioCreativeLayer) {
        var audible = audioCreativeLayer.audible,
            audioURL = audioCreativeLayer.audioURL,
            processedAudio = audioCreativeLayer.processedAudio;
        var hasAudio = !processedAudio || (0, _isNotNil["default"])(audioURL);

        if (audible && hasAudio) {
          audibleCreativeLayersByElementId.set(audioCreativeLayer.elementId, audioCreativeLayer);
        }
      });
      this._audibleCreativeLayersByElementId = audibleCreativeLayersByElementId;
    }
  }, {
    key: "stopAll",
    value: function stopAll() {
      this._elementAudio.forEach(function (audioLayer, key) {
        var audio = audioLayer.audio;
        if ((0, _isNil["default"])(audio)) return;

        if (audio.isPlaying) {
          audio.stop();
        }
      });
    }
  }, {
    key: "stopAudioThatShouldNotBePlaying",
    value: function stopAudioThatShouldNotBePlaying(uppermostAudioElementId) {
      var _this2 = this;

      this._elementAudio.forEach(function (audioLayer, key) {
        if (key === uppermostAudioElementId) return;
        var audio = audioLayer.audio;
        if ((0, _isNil["default"])(audio)) return; // Stop audio

        if (audio.isPlaying) {
          audio.stop();
        }

        if (!_this2._audibleCreativeLayersByElementId.has(key)) {
          // TODO make sure this is the right way to do this
          audio.clear();

          _this2._elementAudio["delete"](key);
        }
      });
    }
  }, {
    key: "getAudio",
    value: function getAudio(currentFrame) {
      // Get active audio layers
      var activeAudioCreativeLayers = [];

      this._audibleCreativeLayersByElementId.forEach(function (audioCreativeLayer) {
        if (audioCreativeLayer.isActiveInFrame(currentFrame)) {
          activeAudioCreativeLayers.push(audioCreativeLayer);
        }
      });

      var uppermostAudioCreativeLayer = (0, _isNotEmpty["default"])(activeAudioCreativeLayers) ? activeAudioCreativeLayers[activeAudioCreativeLayers.length - 1] : undefined; // If nothing should be playing, don't play anything.

      if (!_AudioCreativeLayer["default"].isAudioCreativeLayer(uppermostAudioCreativeLayer)) {
        this.stopAll();
        return false;
      } // If for some reason the uppermost audio element is not audible, stop playing


      var elementId = uppermostAudioCreativeLayer.elementId,
          audible = uppermostAudioCreativeLayer.audible;

      if (!audible) {
        this.stopAll();
        return false;
      } // Load up audio


      this.loadAudioThatHasNotBeenLoaded(); // Go through audio map and stop anything that shouldn't be playing
      // Remove anything that shouldn't exist anymore

      this.stopAudioThatShouldNotBePlaying(elementId); // Get playing audio and play it.

      this.playAudioThatShouldBePlaying(uppermostAudioCreativeLayer, currentFrame);
      return true;
    }
  }, {
    key: "creative",
    get: function get() {
      return this._creative;
    },
    set: function set(value) {
      this._creative = value;
      this.setUpAudioLayers();
    }
  }, {
    key: "speed",
    get: function get() {
      return this._speed;
    },
    set: function set(value) {
      this._speed = value;

      this._elementAudio.forEach(function (elementAudio) {
        elementAudio.speed = value;
      });
    }
  }]);
  return SnapAudio;
}();

var getSnapAudio = function getSnapAudio(creative, audioFactory) {
  return new SnapAudio(creative, audioFactory);
};

var _default = getSnapAudio;
exports["default"] = _default;